
export const currencyOptions:any = [
    {
      label: 'JPY',
      value: 'JPY', 
    },
    {
      label: 'SGD',
      value: 'SGD', 
    },
    {
      label: 'USD',
      value: 'USD', 
    },
    {
      label: 'HKD',
      value: 'HKD', 
    },
    {
      label: 'PHP',
      value: 'PHP', 
    },
  ];

  export const CURRENCY_FORMATS_OPTIONS : any = {
    JPY: 'JPY',
    SGD: 'SGD',
    USD: 'USD',
    HKD: 'HKD',
    PHP: 'PHP',
  };
